export function ofsaWhatSlider() {
	'use strict';

	const el = document.querySelector( '.what-slider' );
	if ( ! el ) return;

	new Swiper( '.what-slider', {
		effect: 'fade',
		fadeEffect: { crossFade: true },
		loop: true,
		autoHeight: true,
		speed: 800,
		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
		},
		on: {
			autoplayTimeLeft( swiper, timeLeft, progress ) {
				const activeSlide = swiper.slides[ swiper.activeIndex ];
				if ( ! activeSlide ) return;
				const bar = activeSlide.querySelector( '.what-slider-progress-bar' );
				if ( bar ) {
					bar.style.transform = `scaleX(${ 1 - progress })`;
				}
			},
			slideChange( swiper ) {
				swiper.slides.forEach( ( slide ) => {
					const bar = slide.querySelector( '.what-slider-progress-bar' );
					if ( bar ) {
						bar.style.transform = 'scaleX(0)';
					}
				} );
			},
		},
	} );
}
